import { AnimatedButtonContainer, AnimatedButtonRow, Button } from "@babackapp/customer-ui/components/button";
import { Header, HeaderDescription, HeaderTitle } from "@babackapp/customer-ui/components/header";
import { WidgetPage } from "@babackapp/customer-ui/components/widget-page";
import { UserPortalCallout } from "@babackapp/return-widget-components/components/user-portal-callout";
import { useCustomText } from "@babackapp/return-widget-components/hooks/use-custom-text";
import { usePublicShop } from "@babackapp/return-widget-components/queries/use-public-shop";
import { EnterIcon } from "@radix-ui/react-icons";
import { Link } from "react-router-dom";
import { useWidgetParams } from "../hooks/use-widget-params";

export function NoPhysicalReturn() {
  const t = useCustomText();
  const { shopId } = useWidgetParams();
  const { data: shop } = usePublicShop(shopId);

  return (
    <WidgetPage variant="centered">
      <Header>
        <HeaderTitle>{t("noPhysicalReturn.title")}</HeaderTitle>
        <HeaderDescription>{t("noPhysicalReturn.description")}</HeaderDescription>
      </Header>

      <UserPortalCallout texts={shop?.preferences?.userPortal?.endProcessWithoutPhysicalReturn} />

      <AnimatedButtonRow variants={{}}>
        <AnimatedButtonContainer layoutId="line-item-confirm-button" variants={{}}>
          <Link to="../complete">
            <Button>
              <EnterIcon />
              {t("common.confirm")}
            </Button>
          </Link>
        </AnimatedButtonContainer>
      </AnimatedButtonRow>
    </WidgetPage>
  );
}
